module.exports = __webpack_public_path__ + "img/1508982772.f8286b7f.jpg";